var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Head'),_c('div',{staticClass:"main__frame",attrs:{"id":"mainframe"}},[_c('router-view')],1),_c('Footer',{attrs:{"year":new Date().getFullYear()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }